import './Connect.css'
import { Flex } from 'antd'
import { FC } from "react"
import { connect } from '../../contents/connect'
import { useResponxiveContext } from '../../context/responsive-context'
import { TransparentButton } from '../../common-components/CustomButtons'

export const Connect: FC = () => {
  const { useVertical } = useResponxiveContext()
  return (
    <>
    {!useVertical &&
    <Flex className="Connect-container" justify={'space-evenly'}>
      <Flex className="Connect-picture-container" justify={'start'}>
          <div className="Connect-picture">
      <Flex vertical justify={'end'} align={'center'} style={{height: '85vh'}}>
        <h1 className="Connect-header" >Tudtad, hogy összekötheted a szín- és testalkat tanácsadást?</h1>
      </Flex>
      <Flex vertical align={'center'} justify={'center'} style={{height: '15vh'}}>
              <TransparentButton
              href='#book'
              >
                {"FOGLALÁS"}
              </TransparentButton>
      </Flex>
          </div>
      </Flex>

      <Flex vertical className="Connect-details-container" justify={'center'} align={'center'} gap={'middle'}>
          <div className="Connect-details">{connect.body[0]}</div>
          <div className="Connect-details">{connect.body[1]}</div>
      </Flex>
    </Flex>
    }
    { useVertical &&
    <Flex className="Connect-container-vertical" vertical justify={'center'} align={'center'}>
      <Flex className="Connect-header-vertical" vertical justify={'start'} align={'center'} >
        <div  >Tudtad, hogy összekötheted a szín- és testalkat tanácsadást?</div>
      </Flex>
      <Flex vertical className="Connect-details-vertical" justify={'end'} align={'center'} gap={'middle'}>
          <>
          <div>{connect.body[0]}</div>
          <div>{connect.body[1]}</div>
          </>
      </Flex>
      <Flex vertical justify={'start'} style={{height: '30vh', paddingTop: 35}}>
              <TransparentButton
              href='#book'
              >
                {"FOGLALÁS"}
              </TransparentButton>
      </Flex>
    </Flex>
    }
    </>
  )
}
